<template>
	<div id="app">
		<InjectEditorPracticeJS @injectJSFinish="injectJSFinish"></InjectEditorPracticeJS>
		<game-render ref="game" v-if="injectJSLoadFinish && pageName && (notShowGamePage.indexOf(pageName) === -1)"
			:style="{visibility:(showGamePage.indexOf(pageName) !== -1)?'visible':'hidden'}" :problem-info="problemInfo"
			:user-homework-result="userHomeworkResult" @commitResult="commitResult" @openUnlockProblem="openUnlockProblem"
			v-on:hook:mounted="handleChildMounted" :lang="lang" :size="size" :top="top" @runningGame="runningGame" @initUserHomeworkResult="initUserHomeworkResult"></game-render>
		<router-view />
	</div>
</template>
<script>
	import gameRender from "./components/gameRender";
	import InjectEditorPracticeJS from "./components/InjectEditorPracticeJS";
	// 创建 BroadcastChannel 对象
	const eventBus = new BroadcastChannel('eventBus')
	export default {
		components: {
			gameRender,
			InjectEditorPracticeJS
		},
		data() {
			return {
				userHomeworkResult: null, // 作业结果
				homeWorkItem: null, // 当前题目
				problemInfo: null, // 题目详情
				injectJSLoadFinish: false, // 是否初始化编程星球
				pageName: "", // 当前路由名
				showGamePage: ['doTheHomework', 'codeGuardian', 'competition', 'pblEditor'], // 需要加载游戏场景的路由
				notShowGamePage: ['cEditor','pyEditor'],
				size: 0.1,
				top: "55.5%",
        lang: 1
			}
		},
		watch: {
			$route(to) {
				// console.log(to.name)
				this.pageName = to.name;
				if (to.name == "competition") {
					this.size = 0.21;
					this.top = "50%";
				}else{
          this.size = 0.1;
          this.top = "55.5%";
        }
			}
		},
		created() {
			// 监听 message 事件
			eventBus.addEventListener('message', event => {
				let data = event.data;
				// console.log('**************event.data=',data,'*******************')
				if (this.$refs.game) {
					if (data.event === 'showCodeBattleMainScene') { // 显示源码战争场景
						this.$refs.game.setState(data.data.isShow)
            this.userHomeworkResult = null
						this.$refs.game.loadCodeBattleMainScene(data.data.width, data.data.height);
					} else if (data.event === 'gameNoticeReloadChipInfo') { // 给游戏发送重新加载题目信息
						this.$refs.game.gameNoticeReloadChipInfo()
					} else if (data.event === 'show') { // 显示游戏接口
						this.$refs.game.setState(data.data.isShow)
					} else if (data.event === 'problemInfo') { // 切换题目接口
						this.$refs.game.setState(data.data.isShow)
						this.problemInfo = data.data.problemInfo // 接收题目详情
            this.$refs.game.resizeCanvasContainer(0,0,'homework')
						this.userHomeworkResult = null
					} else if (data.event === 'homeworkResult') {
						this.userHomeworkResult = data.data.homeworkResult // 接收题目结果
					} else if (data.event === 'gameNoticeCaptureAllKeyboardInput') {
						this.$refs.game.gameNoticeCaptureAllKeyboardInput(data.data.msg)
					} else if (data.event === 'showPBLEditor') {
            this.userHomeworkResult = null
            this.$refs.game.setState(data.data.isShow)
            this.$refs.game.loadPBLEditorMainScene(data.data.width, data.data.height);
          } else if (data.event === 'changeLang') {
					  this.changeLang(data.data.lang)
          } else if (data.event === 'gameLoadGameEditorScene') {
            this.$refs.game.setState(data.data.isShow)
            this.problemInfo = data.data.problemInfo
            this.userHomeworkResult = null
          }
				}
			})
		},
		mounted: function() {
			this.setBodyFintSize();
			window.onresize = () => {
				return (() => {
					this.setBodyFintSize();
				})();
			};
		},
		methods: {
			setBodyFintSize() {
				var html = document.getElementsByTagName("html")[0];
				var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
				html.style.fontSize = oWidth / 1920 * 25 + "px";
			},
			// 初始化编程星球
			injectJSFinish: function(val) {
				this.injectJSLoadFinish = val
			},
			commitResult(data) { // 提交作业
				eventBus.postMessage({
					event: 'submitGame',
					data: data
				})
			},
			handleChildMounted() {
				// 这里可以进行相关操作
				// this.$refs.game.setState(false);
			},
			openUnlockProblem(msg) {
				eventBus.postMessage({
					event: 'openUnlockProblemDialog',
					data: {
						problemId: msg
					}
				})
			},
			runningGame(type) {
				eventBus.postMessage({
					event: 'runningGame',
					data: type
				})
			},
      initUserHomeworkResult() {
			  this.userHomeworkResult = null
      },
      changeLang(lang) {
			  this.lang = lang
      }
		}
	}
</script>
<style lang="scss" scoped>
	@import "./assets/css/main.css";

	#app {
		width: 100%;
		height: 100%;
	}

	pre,
	p {
		margin: revert;
	}

	// 表格样式
	::v-deep .el-table {
		color: #FFF;
		font-size: 0.72rem;
		margin-bottom: 1.6rem;

		thead,
		.el-table__empty-block span {
			color: #FFF;
		}

		.el-table__cell {
			padding: 0.48rem 0;
		}

		th.el-table__cell,
		tr,
		.el-table__empty-block {
			background-color: #1D4E64;
		}

		td.el-table__cell,
		th.el-table__cell.is-leaf,
		td.el-table__cell,
		th.el-table__cell.is-leaf {
			border-bottom: 1px solid #3D5E6F;
		}

		.el-button {
			background-color: #27A364 !important;
		}
	}

	::v-deep .el-table.el-table--border::after,
	::v-deep .el-table.el-table--group::after,
	::v-deep .el-table::before {
		background-color: #1D4E64;
	}

	::v-deep .el-table.el-table--border,
	::v-deep .el-table.el-table--group {
		border: 1px solid #3D5E6F !important;
	}

	::v-deep .el-table--border .el-table__cell,
	::v-deep .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
		border-right: 1px solid #3D5E6F !important;
	}

	::v-deep .el-table__body tr.current-row>td.el-table__cell,
	::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
		background-color: #69BBC4;
	}
</style>

<style lang="scss">
	// 改变pop框颜色
	.explain-popover {
		background: rgba(29, 55, 72, 0.82) !important;
		border-color: #3EA9B2 !important;
		border-radius: 4px !important;
		color: #fff !important;

		p {
			line-height: 26px;
			font-size: 16px;
		}
	}

	.explain-popover[x-placement^=top] .popper__arrow::after {
		border-top-color: rgba(29, 55, 72, 0.82) !important;
	}

	.explain-popover[x-placement^=top] .popper__arrow {
		border-top-color: rgba(29, 55, 72, 0.82) !important;
	}

	.explain-popover[x-placement^=bottom] .popper__arrow::after {
		border-bottom-color: rgba(29, 55, 72, 0.82) !important;
	}

	.explain-popover[x-placement^=bottom] .popper__arrow {
		border-bottom-color: rgba(29, 55, 72, 0.82) !important;
	}
</style>
